import { motion } from "framer-motion";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import BackButton from "../components/BackButton";
import api from "../services/api";

const EditIssuePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [issue, setIssue] = useState(null);

  // ✅ fetchIssue wrapped in useCallback (fix ESLint dependency warning)
  const fetchIssue = useCallback(async () => {
    try {
      const res = await api.get(`/issues/${id}`);
      setIssue(res.data);
    } catch (err) {
      console.error("Issue fetch failed:", err);
      toast.error("Failed to load issue.");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchIssue();
  }, [fetchIssue]);

  const handleChange = (e) => {
    setIssue({ ...issue, [e.target.name]: e.target.value });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      const res = await api.patch(`/issues/${id}/edit`, issue);

      if (res.status === 200) {
        toast.success("✅ Issue updated. Sent for re-verification.");
        navigate("/my-issues");
      } else {
        toast.error(res.data.message || "Update failed.");
      }
    } catch (err) {
      console.error("Update error:", err);
      toast.error("Something went wrong.");
    }
  };

  if (loading)
    return <p className="text-center py-10">Loading...</p>;

  if (!issue)
    return (
      <p className="text-center py-10 text-red-500">
        Issue not found
      </p>
    );

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-green-50 py-10 px-4">
      <div className="max-w-3xl mx-auto bg-white p-6 rounded-xl shadow border space-y-6">
        <BackButton />

        <motion.h1
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-3xl font-bold text-orange-700"
        >
          ✏️ Edit Your Issue
        </motion.h1>

        <form onSubmit={handleUpdate} className="space-y-4">

          <input
            type="text"
            name="title"
            value={issue.title || ""}
            onChange={handleChange}
            className="w-full border px-4 py-2 rounded"
            placeholder="Issue Title"
            required
          />

          <textarea
            name="description"
            value={issue.description || ""}
            onChange={handleChange}
            className="w-full border px-4 py-2 rounded"
            rows={5}
            placeholder="Describe the issue..."
            required
          />

          <select
            name="category"
            value={issue.category || ""}
            onChange={handleChange}
            className="w-full border px-4 py-2 rounded"
            required
          >
            <option value="">Select Category</option>
            <option value="Road">Road</option>
            <option value="Water">Water</option>
            <option value="Electricity">Electricity</option>
            <option value="Women">Women Safety</option>
            <option value="Unemployment">Unemployment</option>
            <option value="School">School</option>
            <option value="Police">Police</option>
            <option value="Other">Other</option>
          </select>

          <button
            type="submit"
            className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded font-semibold"
          >
            Update Issue
          </button>

        </form>

        <p className="text-xs text-center text-gray-500 italic pt-4">
          All edited issues are reviewed by AI and verified again by admin for safety and transparency.
        </p>

      </div>
    </div>
  );
};

export default EditIssuePage;
